import { Zap, Github } from 'lucide-react'
import CodebaseDiscovery from './CodebaseDiscovery'

export default function CodebasePage() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Github className="w-4 h-4 text-aith-accent" />
        <h2 className="text-xs font-bold tracking-widest text-gray-500 uppercase">Codebase Discovery</h2>
        <span className="ml-auto text-[10px] text-gray-600">100M+ repos indexed</span>
      </div>

      <p className="text-[10px] text-gray-500">
        Search, ingest, and analyze any public GitHub repository. The team finds what the world has already built.
      </p>

      <CodebaseDiscovery />
    </div>
  )
}
